import './PlayerBet.styles.css';

import { observer } from 'mobx-react';
import { FC, useContext, useMemo } from 'react';

import { GameContext } from '../../context/GameContext/GameContext';
import useScreenDimensions from '../../hooks/useScreenDimensions';
import commonStore from '../../store/CommonStore';
import tableStore from '../../store/TableStore';
import { formatNumber } from '../Game/table.render.utils';
import { PlayerBetProps } from './PlayerBet.types';

const PlayerBet: FC<PlayerBetProps> = ({ totalBet, playerBetPosition }) => {
  const { isSingleTable } = useContext(GameContext);

  const { screenWidth } = useScreenDimensions();

  const totalBetString = useMemo(() => {
    if (totalBet) {
      return formatNumber(totalBet);
    }
  }, [totalBet]);

  const betImageWidth = useMemo(() => {
    if (
      (isSingleTable &&
        screenWidth > 1000 &&
        !tableStore.viewingModalWindowTableId) ||
      (tableStore.viewingModalWindowTableId && screenWidth > 1400)
    ) {
      return 35;
    } else {
      return 20;
    }
  }, [screenWidth, tableStore.viewingModalWindowTableId]);

  return (
    totalBet > 0 && (
      <div
        className="player-bet"
        style={{ left: playerBetPosition.betX, top: playerBetPosition.betY }}
      >
        <img
          width={betImageWidth}
          className="bet-image"
          src="/assets/bet.svg"
          alt="player-bet"
        />
        <div className="bet-value ms-1">
          {totalBetString}
          {commonStore.getIsChipsConvertedToBlinds() && (
            <span className="bb-text">{' BB'}</span>
          )}
        </div>
      </div>
    )
  );
};

export default observer(PlayerBet);
